import { client } from "@/api/client";
import interceptors from "@/api/interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getOptionGender() {
	return client.get("api-logistic/options/driver-gender");
}

export default {
	getOptionGender,
};